import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { images } from "../data/business";

export default function TransitionBreak() {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start end", "end start"],
    });
    const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

    return (
        <section
            ref={ref}
            data-testid="transition-break"
            className="relative h-[60vh] min-h-[420px] overflow-hidden"
        >
            <motion.img
                src={images.nailsChrome}
                alt="Detalhe de acabamento em unhas"
                loading="lazy"
                style={{ y }}
                className="absolute inset-0 h-[116%] w-full object-cover"
            />
            <div className="absolute inset-0 bg-ink/40" />
            <div className="relative flex h-full items-center justify-center px-6">
                <motion.p
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.4 }}
                    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                    className="max-w-4xl text-center font-display text-3xl font-medium uppercase leading-[1.15] tracking-tight text-paper sm:text-5xl"
                >
                    Bonito na foto.
                    <br />
                    <span className="italic text-accent">Ainda melhor nos detalhes.</span>
                </motion.p>
            </div>
        </section>
    );
}
